module.exports = __webpack_public_path__ + "static/img/freezer_onsen.35fad1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_onsen.jpg
// module id = kiuo
// module chunks = 1